import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { LoaderService } from "src/app/shared/services/loader.service";
import packageInfo from "../../../../../package.json";
import { UserViewModel } from "../../models/user.viewmodel";
import { TokenService } from "../../token.service";
import { UserService } from "../../user.service";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { MaintenanceMessageService } from "src/app/core/admin-panel/services/MaintenanceMessage.service"
import { MaintenanceMessageDto } from "src/app/core/admin-panel/models/MaintenanceMessageDto";

import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
const version = packageInfo.version;

@Component({
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.scss"],
})
export class LoginFormComponent implements OnInit, OnDestroy {
  public version: string = version;
  public maintenanceMessage: MaintenanceMessageDto | null = null;
  public showMaintenanceMessage: boolean = false;

  @Output() userLoggedIn: EventEmitter<any> = new EventEmitter<any>();
  loginForm: FormGroup;
  loginDisplay = false;

  constructor(
    private loaderService: LoaderService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private tokenService: TokenService,
    private userService: UserService,
    private maintenanceMessageService: MaintenanceMessageService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.loaderService.hide();
  }

  ngOnInit() {
    this.msalBroadcastService.msalSubject$.subscribe((result: EventMessage) => {
      if (
        result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        result.eventType === EventType.LOGIN_SUCCESS
      ) {
        const authResult = result.payload as AuthenticationResult;
        if (authResult && authResult.account) {
          const authUser = new UserViewModel({
            mail: authResult.account.username,
            entraToken: authResult.idToken,
          });
          this.loaderService.show();
          this.userService
            .userAuthentication(authUser)
            .pipe(first())
            .subscribe(
              (res) => {
                this.tokenService.setToken(res.token);
                this.userLoggedIn.emit(res);
              },
              () => {
                this.loaderService.hide();
              }
            );
        }
      }
    });
    this.loadMaintenanceMessage();
  }

  login() {
    this.msalService.loginRedirect();
  }
  // isMaintenanceActive(): boolean {
  //   let isActive = false;
  //   this.maintenanceMessageService.getmaintenancemessage().pipe(first()).subscribe(
  //     (msg) => {
  //     this.maintenanceMessage = msg;
  //     if (msg && msg.isActive) {
  //       isActive = true;
  //     }
  //     }
  //   );
  //   return  isActive;
  // }


  private loadMaintenanceMessage(): void {
    this.maintenanceMessageService.getmaintenancemessage().subscribe(
      (data: MaintenanceMessageDto) => {
        this.maintenanceMessage = data;
        this.showMaintenanceMessage = data.isActive;
      },
      (error) => {
        console.error('Error loading maintenance message:', error);
      }
    );
  }
}
